// src/data/winddown.js
//
// Wind-down routine (built from the Sleep checklist's advice, run as a timed
// guide) and the daily Decompress prompt. Both are private-journal features.

// Steps a member can pick from — the Sleep checklist, made runnable.
export const SUGGESTED_STEPS = [
    { id: 'screens', title: 'Screens off', minutes: 2, detail: 'Phone on charge outside the bedroom or face-down on Do Not Disturb. Dim the lights.' },
    { id: 'list', title: 'Empty your head', minutes: 5, detail: "Write tomorrow's list and anything bothering you, with the one thing you'll do about it tomorrow." },
    { id: 'room', title: 'Cool the room', minutes: 2, detail: 'Aim for 15–19°C, as dark as you can make it. Window, blind, fan.' },
    { id: 'shower', title: 'Warm shower or bath', minutes: 10, detail: 'The drop in body temperature afterwards helps deep sleep start.' },
    { id: 'stretch', title: 'Gentle stretch', minutes: 5, detail: 'Slow, easy, nothing that raises your heart rate. Hips, back, neck.' },
    { id: 'breathe', title: 'Slow breathing', minutes: 4, detail: 'Longer out than in. Four in, six out, for a few minutes.' },
    { id: 'read', title: 'Read something low-key', minutes: 10, detail: 'Paper if you can. Not work, not the news.' },
    { id: 'gratitude', title: 'Three good things', minutes: 3, detail: 'Name three things from today that were okay or better. Small counts.' },
    { id: 'lightsout', title: 'Lights out', minutes: 1, detail: 'Same time as last night. Wake time is the anchor — protect it.' }
];

export const DEFAULT_ROUTINE_IDS = ['screens', 'list', 'room', 'breathe', 'lightsout'];

export const stepsFromIds = (ids = DEFAULT_ROUTINE_IDS) =>
    ids.map(id => SUGGESTED_STEPS.find(s => s.id === id)).filter(Boolean).map(s => ({ ...s }));

// A routine -> a guided tool the ResetTool runner can play
export const routineToTool = (steps) => ({
    id: 'winddown',
    title: 'Wind-down',
    minutes: Math.max(1, Math.round(steps.reduce((s, x) => s + (Number(x.minutes) || 0), 0))),
    kind: 'guided',
    intent: 'Wind down',
    blurb: 'Your evening routine, step by step. Same order every night — the body learns the cue.',
    steps: steps.map(s => ({ secs: Math.max(30, Math.round((Number(s.minutes) || 1) * 60)), cue: s.title, detail: s.detail || '' }))
});

// Decompress — one prompt a day, rotating (deterministic by date)
export const DECOMPRESS_PROMPTS = [
    'What do you want to put down before tomorrow?',
    "What went right today that you didn't notice at the time?",
    'What can you leave for tomorrow-you?',
    'Who or what helped today?',
    'What does your body need tonight?',
    'What took more out of you than it should have?',
    'One thing you handled better than you would have a year ago.',
    "What's still running in your head — and what's the first line of the fix?",
    'What would make tomorrow morning easier?',
    'What are you carrying that is not yours to carry?'
];

export const promptForDate = (date = new Date()) => {
    const start = new Date(date.getFullYear(), 0, 0);
    const day = Math.floor((date - start) / 86400000);
    return DECOMPRESS_PROMPTS[day % DECOMPRESS_PROMPTS.length];
};

export const todayKey = (date = new Date()) => date.toISOString().slice(0, 10);
